import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class StageEightService {
  static getStageEight (id) {
    return axios.get(`${url}/admin/stage-eight/fetch/${id}`)
  }
}

export default StageEightService
